import {useQuery} from "@tanstack/react-query";
import {Chain, createPublicClient, http} from "viem";
import matchlog from "../utils/matchlog";

export default function useHash({
    hash,
    chain,
    refetchInterval,
    enabled=true
                                }:{
    hash?: `0x${string}` | null,
    chain?: Chain | null,
    refetchInterval?:false|number
    enabled?:boolean
}){
    return useQuery(
        {
            queryKey: ['txhash', hash, chain],
            queryFn: async () => {
                if (!chain || !hash) return false
                const publicClient = createPublicClient({
                    chain,
                    transport: http(),
                });
                try {
                    const receipt = await publicClient.getTransactionReceipt({hash});

                    if (!receipt) {
                        return 0
                    }
                    matchlog.log('getTransactionReceipt', receipt)
                    if (receipt.status === 'success') {
                        return 1
                    }
                    return -1

                } catch (error) {
                    console.error('getTransactionReceiptError', error)
                }
                return -99
            },
            enabled: !!chain && !!hash && enabled,
            refetchInterval,
            // refetchIntervalInBackground: false
        }
    );
}